/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SalesOrderTax = {
  /**
   * Unique tax identifier
   */
  id: number;
  /**
   * Tax type
   */
  taxType: SalesOrderTax.taxType;
  /**
   * Tax rate percentage
   */
  taxRate: number;
  /**
   * Tax amount
   */
  taxAmount: number;
  /**
   * Tax base amount
   */
  taxBase: number;
  /**
   * Creation timestamp
   */
  createdAt: string;
};
export namespace SalesOrderTax {
  /**
   * Tax type
   */
  export enum taxType {
    IVA = 'IVA',
    IT = 'IT',
  }
}
